<template>
  <Tabs
    :value="modelValue"
    :scrollable="props.scrollable"
    :unstyled="true"
    :pt="passThrough"
    class="meridia-tabs"
    v-bind="$attrs"
    @update:value="onValueUpdate"
  >
    <slot />
  </Tabs>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import Tabs from 'primevue/tabs';
import { usePassThrough } from 'primevue/passthrough';
import type { PassThrough } from '@primevue/core';
import type { TabsPassThroughOptions } from 'primevue/tabs';
import type { MeridiaTabsProps } from 'src/design_system/components/tab/types';

const modelValue = defineModel<string | number>({ required: true });

const props = withDefaults(
  defineProps<MeridiaTabsProps>(),
  {
    scrollable: false,
  }
);

const emit = defineEmits<{
  (e: 'update:modelValue', value: string | number): void;
  (e: 'update:value', value: string | number): void;
}>();

function onValueUpdate(value: string | number) {
  modelValue.value = value;
  emit('update:modelValue', value);
  emit('update:value', value);
}

const passThrough = computed(() =>
  usePassThrough(
    props.pt,
    {
      root: {
        class: 'meridia-tabs-root rounded-none font-bold h-12 w-full flex-none flex flex-col',
      },
    } as TabsPassThroughOptions,
    { mergeSections: false, mergeProps: true }
  ) as PassThrough<TabsPassThroughOptions>
);
</script>
